let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gYLzA")).then(() => parcelRequire('9WB9k'));